import { h } from 'preact'
import { Chart } from '../visual'
import { colors } from '../../constants'

const hasData = data => data && !(data.green === 0 && data.red === 0)
export const PieChart = ({ data, gender, title }) => (
  <div>
    <div style={{ marginBottom: -7 }}>{title}</div>
    <Chart
      data={
        hasData(data)
          ? [
              ['Podpora', 'Procenta'],
              ['Podporuje', data.green],
              [gender === 'M' ? 'Nepřítomen' : 'Nepřítomna', data.grey],
              ['Blokuje', data.red],
            ]
          : [['', { role: 'annotation' }], ['', 0], ['', 100], ['', 0]]
      }
      options={{
        pieHole: 0.7,
        colors: [colors.green, colors.grey, colors.red],
        width: 250,
        height: 140,
        pieSliceText: 'none',
        pieStartAngle: 180,
        chartArea: { left: 0, top: 20, right: 0, bottom: 20 },
        legend: hasData(data)
          ? {
              position: 'labeled',
              maxLines: 3,
              textStyle: { color: 'gray', fontSize: 12 },
            }
          : 'none',
        tooltip: { trigger: 'none' },
        sliceVisibilityThreshold: 0,
      }}
    />
  </div>
)

const LineChart = ({ percent = -1, color }) => (
  <div style={{ display: 'inline-block', width: 250 }}>
    <div
      style={{
        width: 220,
        height: 10,
        backgroundColor: '#e6e6e6',
        display: 'inline-block',
      }}
    >
      <div
        style={{
          width: percent >= 0 ? percent * 2.2 : 0,
          height: 10,
          backgroundColor: color,
        }}
      />
    </div>
    <span
      style={{
        fontSize: '12px',
        paddingLeft: '5px',
        fontWeight: 'bold',
        position: 'relative',
        top: -1,
      }}
    >
      {percent >= 0 && `${percent}%`}
    </span>
  </div>
)

export const ActivityChart = ({ data = {}, nospace }) => (
  <div>
    <div
      style={{
        marginBottom: nospace ? -15 : 10,
        marginLeft: nospace ? 0 : -30,
      }}
    >
      Aktivita
    </div>
    <div
      style={{
        fontSize: 14,
        lineHeight: '1em',
        textAlign: 'left',
        width: 250,
        height: 140,
        marginTop: 23,
      }}
    >
      <p
        style={{
          marginBottom: 5,
        }}
      >
        Pro přijetí funkčních zákonů
      </p>
      <LineChart percent={data.green} color="#8ec641" />
      <p
        style={{
          marginBottom: 5,
          marginTop: 15,
        }}
      >
        Blokování a oslabování zákonů
      </p>
      <LineChart percent={data.red} color={colors.red} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/PoliticianDetail/Charts.js